import CartSummaryContainer from "@app-contexts/public/features/basket/components/CartSummaryContainer/CartSummaryContainer.web";
import { PUBLIC_ROUTES } from "@app-contexts/public/constants/public-routes";
import CheckoutButton from "@shared/components/application/form/CheckoutButton/CheckoutButton.web";
import { useEmbeddedComponent } from "@shared/hooks/useEmbeddedComponent";
import useRedirect from "@shared/hooks/useRedirect.web";
import { useBasketService } from "@shared/modules/basket/context/BasketServiceContext";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";

/**
 * Sticky footer shown inside the best available seating sidebar when the basket
 * already contains items (e.g. user navigated back from checkout).
 * Opens the cart summary modal/drawer so users can review or proceed to checkout.
 *
 * Hidden in widget/embedded contexts — the widget handles its own checkout flow.
 */
export default function BestAvailableBasketFooter(): JSX.Element | null {
  const { t } = useTranslation("seating");
  const { hasItems, totalItemQuantity, paymentVenue } = useBasketService();
  const { redirect } = useRedirect();
  const { isEmbedded } = useEmbeddedComponent();

  if (!hasItems || isEmbedded) return null;

  return (
    <CartSummaryContainer
      displayMode="drawer"
      onCheckout={() => redirect(PUBLIC_ROUTES.CHECKOUT.ROOT)}
      venueId={paymentVenue}
      renderButton={({ onOpen }) => (
        <Flex
          p="md"
          borderTop="1px solid"
          borderColor="border"
          bg="bg"
          position="sticky"
          bottom="none"
        >
          <CheckoutButton
            isDisabled={false}
            onCheckout={onOpen}
            quantityToDisplay={totalItemQuantity}
            customVerbiage={t("View cart")}
          />
        </Flex>
      )}
    />
  );
}
